__turbopack_context__.v({
  "heroOverlay": "hero-module__mIiLda__heroOverlay",
  "heroSection": "hero-module__mIiLda__heroSection",
  "heroTitle": "hero-module__mIiLda__heroTitle",
});
